var FormBuilder = FormBuilder || {};

FormBuilder.Base = (function ($) {
    'use strict';

    function LocationsSelectComponent() {

        const geocoder = new google.maps.Geocoder();
        const selects = $("select[data-locationsselectzipcodefield]");

        selects.each(function () {

            const selectField = $(this);

            // WF: https://experience.adobe.com/#/@zag/so:zag-Production/workfront/task/6a0b187d0005aab7976852a38f7ec5dd
            // Remove Iselin Branch option from all locations select fields
            selectField.find("option").filter(function () {
                return $(this).text().trim() === "Iselin Branch";
            }).remove();

            const selectFieldOriginal = selectField.html();
            const selectFieldEmpty = selectField.find("option").first();
            const formName = selectField.attr("name").split(".")[0];
            const zipCodeFieldName = selectField.attr("data-locationsselectzipcodefield");
            const zipCodeField = selectField.parents("form").find(`[name^=\"${formName}.${zipCodeFieldName}\"]`);

            zipCodeField.on("keyup", function () {
                if ($(this).val().length == 0) {
                    updateSelect();
                }
                else if ($(this).val().substring(0, 5).length == 5) {
                    updateSelect($(this).val().substring(0, 5));
                }
            });

            function updateSelect(zipCode) {

                const selectFieldValue = selectField.val();

                if (zipCode == null) {
                    selectField.html(selectFieldOriginal).val(selectFieldValue);
                    return;
                }

                getLatLong(zipCode).then(latLong => {

                    if (latLong == null) {
                        selectField.html(selectFieldOriginal).val(selectFieldValue);
                        return;
                    }

                    getLocations(latLong).then(locations => {
                        selectField.html(selectFieldEmpty);

                        locations.forEach((loc) => {
                            if (loc.text.trim() === "Iselin Branch")
                                return;

                            const distance = loc.distanceString != 0 ? `(${loc.distanceString}) ` : "";
                            const option = `<option value="${loc.value}">${distance}${loc.text}</option>`;
                            selectField.append(option);
                        });

                        selectField.val(selectFieldValue);
                    });
                });
            }

            function getLatLong(zipCode) {
                return new Promise((resolve) => {

                    // Timeout fallback: return null if geocoder doesn’t respond in 2 seconds
                    const timeout = setTimeout(() => resolve(null), 1000);

                    try {
                        geocoder.geocode({ address: zipCode }, (results, status) => {

                            // cancel the timeout if we get a response
                            clearTimeout(timeout);

                            if (status === 'OK' && results?.length > 0) {
                                resolve([results[0].geometry.location]);
                            } else {
                                resolve(null);
                            }
                        });
                    } catch (err) {
                        clearTimeout(timeout);
                        // catch synchronous errors (e.g., geocoder not defined)
                        resolve(null);
                    }
                });
            }

            function getLocations(latLong) {

                const fetchLocationsParams = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                };

                if (latLong != null) {
                    const fetchLocationsSearchValues = { latitude: latLong[0].lat(), longitude: latLong[0].lng() };
                    fetchLocationsParams.body = JSON.stringify(fetchLocationsSearchValues);
                }

                return fetch("/Api/Locations/GetLocationsSelectOptions", fetchLocationsParams)
                    .then(response => {
                        return response.json();
                    })
                    .catch(error => console.log(error));
            }

        });

    }

    return {
        LocationsSelectComponent: LocationsSelectComponent
    };

})(jQuery);

$(function () {
    FormBuilder.Base.LocationsSelectComponent();
});